import { useEffect } from 'react';
import { findemWidgetEventNames } from 'helpers/findemWidget';
import { useUpdateSourcingCampaignMutation } from 'services/findemV2';

export const useGrowListEvents = ({ sharedList, onCalibrationCompleted, onOutreachCompleted }) => {
  const [updateSourcingCampaign] = useUpdateSourcingCampaignMutation();
  const sourcingCampaignId = sharedList?.sourcingCampaign?.id;
  useEffect(() => {
    const handleCalibrationCompleted = (event) => {
      const { payload } = event.detail || {};

      onCalibrationCompleted?.(payload);
    };

    const handleOutreachCompleted = (event) => {
      const { payload } = event.detail || {};

      onOutreachCompleted?.(payload);
    };

    const handleSessionChange = (event) => {
      const { payload } = event.detail || {};

      if (sourcingCampaignId && payload?.sessionId) {
        const { sessionId, agentId } = payload;

        const updatePayload = { id: sourcingCampaignId };

        updatePayload.sessionId = sessionId;
        if (agentId) {
          updatePayload.agentId = agentId;
        }

        updateSourcingCampaign(updatePayload);
      }
    };

    // Listen for calibration completed event (profile definition done)
    window.addEventListener(findemWidgetEventNames.FINDEM_WIDGET_CALIBRATION_COMPLETED, handleCalibrationCompleted);

    // Listen for outreach completed event (outreach setup done)
    window.addEventListener(findemWidgetEventNames.FINDEM_WIDGET_OUTREACH_COMPLETED, handleOutreachCompleted);

    // Listen for session changes
    window.addEventListener(findemWidgetEventNames.FINDEM_WIDGET_SESSION_CHANGE, handleSessionChange);

    return () => {
      window.removeEventListener(
        findemWidgetEventNames.FINDEM_WIDGET_CALIBRATION_COMPLETED,
        handleCalibrationCompleted,
      );
      window.removeEventListener(findemWidgetEventNames.FINDEM_WIDGET_OUTREACH_COMPLETED, handleOutreachCompleted);
      window.removeEventListener(findemWidgetEventNames.FINDEM_WIDGET_SESSION_CHANGE, handleSessionChange);
    };
  }, [onCalibrationCompleted, onOutreachCompleted, sourcingCampaignId, updateSourcingCampaign]);
};
